import { KngBreadcrumbState } from './definitions';

export class KngBreadcrumbFactory 
{
	public static build(): KngBreadcrumbState 
	{
		return {
			breadcrumbData: [
				{
					id: '',
					url: '',
					label: ''
				}
			],
			breadcrumbIcon: {
				url: '',
				alt: ''
			}
		};
	}
}
